export enum ReportResponsiveness {
	// Reports with this option will try to use cache if available
	RESPONSIVE = 'RESPONSIVE',

	// Reports with this option will never use the cache
	NO_CACHE = 'NO_CACHE'
}

